import { useEffect, useRef } from 'react'

interface Props {
  showable: boolean
  text?: string | null
}

/**
 * 특정 컴포넌트위에 로깅용 텍스트 띄우고 싶은 경우 사용
 */
export const useOverlayText = ({ showable, text }: Props) => {
  const ref = useRef<HTMLSpanElement>(null)

  useEffect(() => {
    if (showable && ref) {
      const parentElement = ref.current?.parentElement

      if (parentElement) {
        const computedStyle = window.getComputedStyle(parentElement)

        const originalStyle = {
          border: computedStyle.border,
          boxSizing: computedStyle.boxSizing,
          position: computedStyle.position,
        }

        parentElement.style.border = '2px solid red'
        parentElement.style.boxSizing = 'border-box;'
        if (computedStyle.position !== 'absolute') parentElement.style.position = 'relative'

        return () => {
          if (parentElement?.style) {
            Object.assign(parentElement.style, originalStyle)
          }
        }
      }
    }

    return () => null
  }, [showable, ref])

  const overlayTextStyle = showable
    ? {
        position: 'absolute' as const,
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'red',
        backgroundColor: 'yellow',
        fontSize: '14px',
        whiteSpace: 'nowrap' as const,
        zIndex: 999,
      }
    : {
        display: 'none',
      }

  return {
    OverlayText: (
      <span ref={ref} style={overlayTextStyle}>
        {text}
      </span>
    ),
  }
}
